
import { defineComponent, PropType } from 'vue'
import { mapActions } from 'vuex'
import { OrgGroupsActions } from '~/store/control-panel/groups'
import { EnterpriseGroup, EnterpriseTeam } from '~/types/types'
import MutationFailedError from '~/utils/mutationFailedError'

export default defineComponent({
  name: 'RemoveTeamFromGroupButton',
  props: {
    group: {
      type: Object as PropType<EnterpriseGroup>,
      required: true
    },
    team: {
      type: Object as PropType<EnterpriseTeam>,
      required: true
    }
  },
  data() {
    return {
      showRemoveTeamFromGroupConfirm: false,
      isRemovingTeam: false
    }
  },
  methods: {
    ...mapActions('control-panel/groups', {
      removeTeamFromGroup: OrgGroupsActions.REMOVE_TEAM_FROM_GROUP
    }),
    showConfirm() {
      this.showRemoveTeamFromGroupConfirm = true
    },
    async removeTeam(groupId: string, teamId: string) {
      this.isRemovingTeam = true
      try {
        const response = await this.removeTeamFromGroup({
          groupId,
          teamId
        })
        if (!response) {
          throw new MutationFailedError('An error occured while removing team, please try again.')
        }
        this.$toast.success('Successfully removed team from group.')
      } catch (e) {
        this.$toast.danger((e as Error).message)
      } finally {
        this.$emit('refetch', { refetchAddTeams: true })
        this.isRemovingTeam = false
      }
    }
  }
})
